import type { Card } from '@uno/shared';
import { useT } from '../hooks';
import { fmt } from '../i18n';
import { listThemes } from '../theme/registry';
import type { CardTheme } from '../theme/types';
import { CardFace } from './CardFace';

const SAMPLES: Card[] = [
  { id: 's1', color: 'red', kind: 'number', value: 7 },
  { id: 's2', color: 'blue', kind: 'skip' },
  { id: 's3', color: 'green', kind: 'draw2' },
  { id: 's4', color: 'wild', kind: 'wild4' },
];

interface Props {
  current: CardTheme;
  onSelect: (id: string) => void;
  onClose: () => void;
}

export function ThemePicker({ current, onSelect, onClose }: Props) {
  const t = useT();
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="modal__title">{t.theme.title}</h2>
        <p className="muted">
          {fmt(t.theme.pngHint, { path: 'public/themes/<id>/' })} {t.theme.description}
        </p>

        <div className="themelist">
          {listThemes().map((theme) => (
            <button
              key={theme.id}
              type="button"
              className={`themecard ${theme.id === current.id ? 'themecard--active' : ''}`}
              onClick={() => {
                onSelect(theme.id);
                onClose();
              }}
            >
              <div className="themecard__preview">
                {SAMPLES.map((card) => (
                  <CardFace key={card.id} card={card} theme={theme} />
                ))}
              </div>
              <div className="themecard__meta">
                <strong>{theme.name}</strong>
                {/* The built-in deck's blurb is UI copy; PNG packs carry their own credit. */}
                <em>{theme.kind === 'css' ? t.theme.builtIn : theme.credit}</em>
                <span className="muted">
                  {theme.kind.toUpperCase()} · {theme.width}×{theme.height}
                </span>
              </div>
            </button>
          ))}
        </div>

        <div className="modal__actions">
          <button type="button" className="btn btn--primary" onClick={onClose}>
            {t.common.done}
          </button>
        </div>
      </div>
    </div>
  );
}
